import { jsxs as u, jsx as a } from "react/jsx-runtime";
import b from "react";
import { Wrapper as m, Label as h, Input as L, ErrorLabel as x, HintLabel as I, LinkLabel as j } from "./styled.js";
const v = b.forwardRef(function({
  name: e,
  label: i = "",
  ariaLabel: n = "",
  type: o = "text",
  linkText: t,
  hint: l,
  children: d,
  error: r,
  labelProps: p,
  errorLabelProps: c,
  ...f
}, s) {
  return /* @__PURE__ */ u(m, { children: [
    /* @__PURE__ */ a(h, { htmlFor: e, ...p, children: i }),
    /* @__PURE__ */ a(
      L,
      {
        name: e,
        type: o,
        "aria-label": n,
        "aria-invalid": !!r,
        ...f,
        ref: s
      }
    ),
    d,
    !!r && /* @__PURE__ */ a(x, { ...c, children: r }),
    l && /* @__PURE__ */ a(I, { children: l }),
    t && /* @__PURE__ */ a(j, { as: "button", children: t })
  ] });
});
export {
  v as BaseInput,
  v as default
};
